<template>
    <div id="profile-page">
        <div class="page-heading">
            <h2 class="display-4 montserrat-bold mb-0">Penalties</h2>
            <div class="mt--2 heading-small">Booking Penalties History</div>
        </div>
    
        <!-- <div class="search-bar-container">
            <i class="fas fa-search icon"></i>
            <input type="text" placeholder="Search" class="search-bar">
        </div> -->

        <div class="bg-white shadow-reg list-container">
            <div class="table-navbar">
                <a :class="['table-navbar-item', isStatusActive('all') && 'active']" href="/all" @click.prevent="setStatusFilter('all')">All</a>
                <a :class="['table-navbar-item', isStatusActive('unpaid') && 'active']" href="/unpaid" @click.prevent="setStatusFilter('unpaid')">Unpaid</a>
                <a :class="['table-navbar-item', isStatusActive('paid') && 'active']" href="/paid" @click.prevent="setStatusFilter('paid')">Paid</a>
            </div>
            <div class="list-wrapper">
                <paginated-section :fetch-link="penaltiesFetchLink" :params="penaltiesParams" paginate-path="data.result.penalties" ref="list" simplified>
                    <template slot="loading">
                        <h3 class="text-muted m-0 pt-5 pb-5 text-center">
                            <i class="fas fa-spin fa-spinner mr-2"></i> Loading penalties
                        </h3>
                    </template>
                    <template slot="empty">
                        <h3 class="text-muted m-0 pt-5 pb-5 text-center">No penalties were found</h3>
                    </template>
                    <template slot="body" slot-scope="{ record }">
                        <penalties-list-item :penalty="record" />
                    </template>

                </paginated-section>
            </div>
        </div>

    </div>
</template> 
<script>
import '@styles/table.css';
import PenaltiesListItem from "./PenaltiesListItem";
import { route } from "@utils/network";

export default {
    name: "PenaltiesListPage",

    components: { PenaltiesListItem },

    data: () => ({
        penaltiesFetchLink: route("booking-penalties"),
        loading: false,
        
        penaltiesParams: {
            status: "all",
        }
    }),

    methods: {
        setStatusFilter(status) {
            this.penaltiesParams.status = status;
            this.$refs.list.refresh();
        },
        isStatusActive(status) {
            return this.penaltiesParams.status == status;
        },
    },

    mounted() {
        this.$emit("mounted");
    }
}
</script>